<template>
    <!--买涨买跌弹窗-->
    <div>
        <div class="fixedCon" v-if="Show">
            <div class="masking" @click="clickPop"></div>
            <div class="tcCon">
                <div class="tcTit">
                    <div class="titCon">
                        <ul>
                            <li v-for='(item,index) in tabs' :class="{checked:isTrue==index}" @click="tabclick(index,item)"><span>{{ item.name }}</span></li>
                        </ul>
                    </div>
                </div>
                <div class="errInfo" v-if="errContent.length > 0" v-html="errContent[0]"></div>
                <div class="itemCon">
                    <!--涨跌-->
                    <div class="item">
                        <ul>
                            <li :class="isRise(marketInfo.tick,1,1)" @click="changeDirect(1)"><p>{{$t("trade.products.buy")}}</p><span :class="isRise(marketInfo.tick,1,2)">{{marketInfo.tick.bid}}</span></li>
                            <li :class="isRise(marketInfo.tick,2,1)" @click="changeDirect(2)"><p>{{$t("trade.products.sell")}}</p><span :class="isRise(marketInfo.tick,2,2)">{{marketInfo.tick.ask}}</span></li>
                        </ul>
                    </div>
                    <!--挂单-->
                    <div v-if="isTrue==1" class="item3 border">
                        <p>{{$t("trade.products.type")}}</p>
                        <ul>
                            <li>
                                <input type="radio" value="1" v-model="marketType.pendType" @change="changePendType()"
                                       checked="checked" class="radio" id="radio"/>
                                <label for="radio"><span></span></label>
                                <p>{{$t("trade.products.limitPrice")}}</p>
                            </li>
                            <li>
                                <input type="radio" value="2" v-model="marketType.pendType" @change="changePendType()"
                                       class="radio" id="radio1"/>
                                <label for="radio1"><span></span></label>
                                <p>{{$t("trade.products.justLoss")}}</p>
                            </li>
                        </ul>
                    </div>
                    <div v-if="isTrue==1" class="item3 margin">
                        <div class="inputCon">
                            <span :class="errClass.setPriceClass">({{pendPrice.min}}-{{pendPrice.max}})</span>
                            <div class="border">
                                <div :class="market.setPrice!=''&&Number(market.setPrice)<=Number(pendPrice.min)?'pic cut stop':'pic cut'"
                                     @click="changeSetPrice(1)"><img src="@/assets/images/template/a_chart_reduce.png"/>
                                </div>
                                <input v-model="market.setPrice" :placeholder="$t('trade.products.notSet')"/>
                                <div :class="market.setPrice!=''&&Number(market.setPrice)>=Number(pendPrice.max)?'pic add stop':'pic add'"
                                     @click="changeSetPrice(2)"><img src="@/assets/images/template/a_chart_increase.png"/></div>
                            </div>
                        </div>
                    </div>
                    <!--市价-->
                    <!-- <div class="item1">
                        <p v-if="marketInfo.symbolData">{{$t("trade.products.amount")}}<span>({{$t("trade.products.minAmount")}} ${{marketInfo.symbolData.minAmount}})</span></p>
                        <p v-else>{{$t("trade.products.amount")}}<span>--</span></p>
                        <div class="border">
                            <div :class="market.volume != ''&& Number(market.amount)<= Number(marketInfo.symbolData.minAmount)?'pic cut stop':'pic cut'" @click="changeAmount(1)"><img src="@/assets/images/template/a_chart_reduce.png"/></div>
                            <input class="width" v-model="market.amount" :placeholder="$t('trade.products.notSet')" v-on:blur="blurAmount">
                            <div :class="market.volume != ''&& Number(market.amount)>= Number(marketInfo.symbolData.maxAmount)?'pic add stop':'pic add'" class="pic add" @click="changeAmount(2)"><img src="@/assets/images/template/a_chart_increase.png"/></div>
                        </div>
                        <div class="border" @click="checkInteger"><img
                                src="@/assets/images/template/a_chart_section.png"/></div>
                        <div class="checkInteger">
                            <div class="integerCon" v-if="isInteger">
                                <span v-for="item in amountList" @click="setAmount(item)">{{item}}</span>
                            </div>
                        </div>
                    </div> -->
                    <!--市价-->
                    <div class="item1">
                        <p>{{ $t("trade.products.lot") }}<span :class="errClass.volumeClass">({{ marketInfo.symbolData.minVolumes }}-{{ marketInfo.symbolData.maxVolumes }})</span>
                        </p>
                        <div
                        :class="market.volume != ''&& Number(market.volume)<= Number(marketInfo.symbolData.minVolumes)?'pic cut stop':'pic cut'"
                        @click="changeVolume(1)"
                        ><img src="@/assets/images/template/a_chart_reduce.png"/></div>
                        <input
                        v-model="market.volume"
                        :placeholder="$t('trade.products.notSet')"
                        >
                        <div
                        :class="market.volume != ''&& Number(market.volume)>= Number(marketInfo.symbolData.maxVolumes)?'pic add stop':'pic add'"
                        class="pic add"
                        @click="changeVolume(2)"
                        ><img src="@/assets/images/template/a_chart_increase.png"/></div>
                    </div>
                    <div class="isShow">
                        <div class="titShow">
                            <div class="leftItem" @click="tabName" v-if="switchs">
                                <p>{{$t('trade.products.stopLossSwitch')}}</p>
                                <!-- <img src="@/assets/images/template/a_chart_change.png"/> -->
                            </div>
                            <div class="leftItem" v-else>
                                <p>{{$t('trade.products.stopLossSwitch')}}</p>
                                <!-- <img src="@/assets/images/template/a_chart_change.png"/> -->
                            </div>
                            <div class="rightItem" @click="clickArrow">
                                <img v-if="switchs" src="@/assets/images/template/a_setting_on.png"/>
                                <img v-else src="@/assets/images/template/a_setting_off.png"/>
                            </div>
                        </div>
                        <div class="conHide" v-if="switchs">
                            <div v-if="ProfitLossChanges">
                                <div class="item1">
                                    <!--买涨价+间隔点*pip/大点比率   买涨价+最大间隔点*pip/大点比-->
                                    <p>{{$t('trade.products.stopProfit')}}<span :class="errClass.stopProfitClass">({{stopProfit.min}}-{{stopProfit.max}})</span>
                                    <div class="border">
                                        <div :class="market.stopProfit!='' && Number(market.stopProfit) <= Number(stopProfit.min)?'pic cut stop':'pic cut'" @click="changeStopProfit(1)"><img src="@/assets/images/template/a_chart_reduce.png"/></div>
                                        <input v-model="market.stopProfit" :placeholder="$t('trade.products.notSet')"/>
                                        <div :class="market.stopProfit!='' && Number(market.stopProfit) >= Number(stopProfit.max)?'pic add stop':'pic add'" @click="changeStopProfit(2)"><img src="@/assets/images/template/a_chart_increase.png"/></div>
                                    </div>
                                </div>
                                <div class="item1">
                                    <!--买涨价-最大间隔点*pip/大点比率  买涨价-间隔点*pip/大点比率-->
                                    <p>{{$t('trade.products.stopLoss')}}<span
                                            :class="errClass.stopLossClass">({{stopLoss.min}}-{{stopLoss.max}})</span>
                                    </p>
                                    <div class="border">
                                        <div :class="market.stopLoss!='' && Number(market.stopLoss) <= Number(stopLoss.min)?'pic cut stop':'pic cut'" @click="changeStopLoss(1)"><img src="@/assets/images/template/a_chart_reduce.png"/></div>
                                        <input v-model="market.stopLoss" :placeholder="$t('trade.products.notSet')"/>
                                        <div :class="market.stopLoss!='' && Number(market.stopLoss) >= Number(stopLoss.max)?'pic add stop':'pic add'" @click="changeStopLoss(2)"><img src="@/assets/images/template/a_chart_increase.png"/></div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!ProfitLossChanges">
                                <div class="item1">
                                    <!--买涨价+间隔点*pip/大点比率   买涨价+最大间隔点*pip/大点比-->
                                    <p>{{$t('trade.products.stopProfit')}}<span :class="errClass.stopProfitClass">(${{stopProfit.min}}-${{stopProfit.max}})</span></p>
                                    <div class="item_a">
                                        <p><em>{{$t('trade.products.expectedProfit')}}</em><i class="rise" v-if="lossAndProfit.stopProfit && market.amount && market.amount != ''">{{(100*util.accDiv(lossAndProfit.stopProfit,market.amount)).toFixed(0)}}%</i></p>
                                        <RangeScope v-if="!ProfitLossChanges" :minScope="stopProfit.min" :type="1" :rangeScope="stopProfit.max" :range="market.stopProfit" @changerange=changeRangeProfit></RangeScope>
                                    </div>
                                </div>
                                <div class="item1">
                                    <!--买涨价-最大间隔点*pip/大点比率  买涨价-间隔点*pip/大点比率-->
                                    <p>{{$t('trade.products.stopLoss')}}<span :class="errClass.stopLossClass">(${{stopLoss.min}}-${{stopLoss.max}})</span></p>
                                    <div class="item_a">
                                        <p><em>{{$t('trade.products.expectedLoss')}}</em><i class="fall" v-if="lossAndProfit.stopLoss && market.amount && market.amount != ''">{{(100*util.accDiv(lossAndProfit.stopLoss,market.amount)).toFixed(0)}}%</i></p>
                                        <RangeScope v-if="!ProfitLossChanges" :minScope="stopLoss.min" :type="2" :rangeScope="stopLoss.max" :range="market.stopLoss" @changerange=changeRangeLoss></RangeScope>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <RangeScope
                        v-if="isTrue==0"
                        :range-scope="marketInfo.symbolData.rangeScope"
                        :range="market.range"
                        @changeRange="changeRange"
                    />
                    <!--挂单-->
                    <div v-if="isTrue==1" class="item3 border">
                        <p>{{$t('trade.products.validityPeriod')}}</p>
                        <ul>
                            <li>
                                <input type="radio" value="2" v-model="market.expireType" class="radio" id="radio2"/>
                                <label for="radio2"><span></span></label>
                                <p>{{$t('trade.products.week')}}</p>
                            </li>
                            <li>
                                <input type="radio" value="1" v-model="market.expireType" class="radio" id="radio3"/>
                                <label for="radio3"><span></span></label>
                                <p>{{$t('trade.products.day')}}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="item2">
                        <ul>
                            <li v-if="market.volume && market.volume != '' && marketInfo.symbolData">
                                <p>{{ $t('trade.products.marginUsage') }} ${{ tradeUtil.getMargin(market.volume,marketInfo.symbolData,marketType.direct,tradeData.position) }}</p>
                            </li>
                            <!-- <li v-if="market.volume && market.volume != '' && marketInfo.symbolData"><p>{{$t('trade.products.reference')}} ${{market.amount}}</p></li> -->
                            <li>
                                <div>
                                    <p>{{$t('trade.products.availableMargin')}} $<Available ref="availableChild"></Available></p>
                                </div>
                            </li>
                            <li v-if="lossAndProfit.stopProfit || lossAndProfit.stopLoss">
                                <p>
                                    {{$t('trade.products.expectedProfitLoss')}}
                                    <em v-if="lossAndProfit.stopProfit"
                                        :class="lossAndProfit.stopProfit>0?'rise':'fall'">{{lossAndProfit.stopProfit>=0?'+':'-'}}${{Math.abs(lossAndProfit.stopProfit).toFixed(2)}}</em>
                                    <em v-if="lossAndProfit.stopProfit && lossAndProfit.stopLoss">/</em>
                                    <em v-if="lossAndProfit.stopLoss" :class="lossAndProfit.stopLoss>0?'rise':'fall'">{{lossAndProfit.stopLoss>=0?'+':'-'}}${{Math.abs(lossAndProfit.stopLoss).toFixed(2)}}</em>
                                </p>
                            </li>
                        </ul>
                        <span @click="submit" :class="errContent.length>0 || submitText==$t('message.submitting')?'err':''"><img v-if="submitText==$t('message.submitting')" src="@/assets/images/template/loading1.gif"/>{{submitText}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!--提交失败提示-->
        <div class="popFixed" v-if="isError">
            <div class="masking" @click="errPop"></div>
            <div class="tcCon">
                <div class="item">
                    <p>{{errMessage}}</p>
                </div>
                <div class="btnCon only">
                    <span @click="errPop">{{$t("message.definite")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    import Constant from '@/utils/Constant'
    import Available from '@/view/module/Available.vue'
    import RangeScope from '@/view/quotation/RangeScope.vue'

    export default {
        name: "MarketNorm",
        props: ['code',],
        components: {Available, RangeScope},
        computed: {
            ...mapState(['quote', "symbolInfo", 'socket', 'account', 'orderAddRet', 'positionAddRet', 'tradeData', 'simpleResponse', 'group']),
            marketInfo: {
                get() {
                    let symbolData = {};
                    let tick = {};
                    if (this.quote.notify[this.code]) {
                        const source = this.quote.notify[this.code].uiSourceCode;
                        if (this.symbolInfo.codeMap[source]) symbolData = this.symbolInfo.codeMap[source];
                    }
                    if (this.quote.codeTickMap && this.quote.codeTickMap[this.code]) tick = this.quote.codeTickMap[this.code];
                    //if (symbolData && this.market.volume == "") this.market.volume = symbolData.minVolumes;
                    return {
                        symbolData: symbolData,
                        tick: tick
                    };
                }
            },
            //金额范围
            amountList: {
                get() {
                    let amountRange = [];
                    let volumesList = this.marketInfo.symbolData.volumesList;
                    for (let i in volumesList) {
                        amountRange.push(this.util.accMul(volumesList[i], this.marketInfo.symbolData.marginInitial))
                    }
                    return amountRange
                }
            },
            /*挂单价格范围*/
            pendPrice: {
                get() {
                    let min = "", max = "";
                    if (this.marketType.type == 2 && this.marketInfo) {
                        if (this.marketType.pendType == 1) {//限价
                            if (this.marketType.direct == 1) {//买
                                min = this.util.accSub(this.marketInfo.tick.bid, this.marketInfo.symbolData.maxStopLevel * this.marketInfo.symbolData.pipv);
                                max = this.util.accSub(this.marketInfo.tick.bid, this.marketInfo.symbolData.stopLevel * this.marketInfo.symbolData.pipv);
                            } else {//卖
                                min = this.util.accAdd(this.marketInfo.tick.ask, this.marketInfo.symbolData.stopLevel * this.marketInfo.symbolData.pipv);
                                max = this.util.accAdd(this.marketInfo.tick.ask, this.marketInfo.symbolData.maxStopLevel * this.marketInfo.symbolData.pipv);
                            }
                        } else {//停损
                            if (this.marketType.direct == 1) {//买
                                min = this.util.accAdd(this.marketInfo.tick.bid, this.marketInfo.symbolData.stopLevel * this.marketInfo.symbolData.pipv);
                                max = this.util.accAdd(this.marketInfo.tick.bid, this.marketInfo.symbolData.maxStopLevel * this.marketInfo.symbolData.pipv);
                            } else {//卖
                                min = this.util.accSub(this.marketInfo.tick.ask, this.marketInfo.symbolData.maxStopLevel * this.marketInfo.symbolData.pipv);
                                max = this.util.accSub(this.marketInfo.tick.ask, this.marketInfo.symbolData.stopLevel * this.marketInfo.symbolData.pipv);
                            }
                        }
                    }
                    const fix = this.marketInfo.symbolData.digits;//价格报价小数位
                    return {
                        min: Number(min).toFixed(fix),
                        max: Number(max).toFixed(fix)
                    }
                },
            },
            /*止损信息*/
            stopLoss: {
                get() {
                    let price;
                    if (this.marketType.type == 1) price = this.marketType.direct == 1?this.marketInfo.tick.bid:this.marketInfo.tick.ask;//市价
                    else if (this.marketType.type == 2) price = this.market.setPrice;//挂单
                    return this.tradeUtil.stopLevelMinAndMax(price, this.marketInfo.symbolData,this.marketType.profit,this.marketType.direct,true,this.market.volume);
                }
            },
            /*止盈信息*/
            stopProfit: {
                get() {
                    let price;
                    const fix = this.marketInfo.symbolData.digits;//价格报价小数位
                    if (this.marketType.type == 1) price = this.marketType.direct == 1?this.marketInfo.tick.bid:this.marketInfo.tick.ask;//市价
                    else if (this.marketType.type == 2) price = this.market.setPrice;//挂单
                    return this.tradeUtil.stopLevelMinAndMax(price, this.marketInfo.symbolData,this.marketType.profit,this.marketType.direct,false,this.market.volume);
                }
            },
            //预期盈亏
            lossAndProfit: {
                get() {
                    let loss = null, profit = null;//sub买卖差价
                    if (this.market.stopLoss && this.market.stopLoss != "") { //亏
                        loss = TradeUtil.lossAndProfit(this.market.stopLoss, this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.market.volume, this.marketInfo.symbolData, this.marketType.direct, this.marketType.profit);
                    }
                    if (this.market.stopProfit && this.market.stopProfit != "") { //盈
                        profit = TradeUtil.lossAndProfit(this.market.stopProfit, this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.market.volume, this.marketInfo.symbolData, this.marketType.direct, this.marketType.profit);
                    }
                    return {
                        stopLoss: loss ? this.marketType.profit==2?-loss:loss: null,
                        stopProfit: profit ? profit: null
                    }
                }
            },
            errClass: {
                get() {
                    let amountClass = this.market.amount != '' && (Number(this.market.amount) > Number(this.marketInfo.symbolData.maxAmount) || Number(this.market.amount) < Number(this.marketInfo.symbolData.minAmount)) ? 'err' : '';
                    let stopLossClass = this.market.stopLoss != '' && (Number(this.market.stopLoss) > Number(this.stopLoss.max) || Number(this.market.stopLoss) < Number(this.stopLoss.min)) ? 'err' : '';
                    let stopProfitClass = this.market.stopProfit != '' && (Number(this.market.stopProfit) > Number(this.stopProfit.max) || Number(this.market.stopProfit) < Number(this.stopProfit.min)) ? 'err' : '';
                    let setPriceClass = this.market.setPrice != '' && (Number(this.market.setPrice) > Number(this.pendPrice.max) || Number(this.market.setPrice) < Number(this.pendPrice.min)) ? 'err' : '';
                    return {
                        amountClass: amountClass,
                        stopLossClass: stopLossClass,
                        stopProfitClass: stopProfitClass,
                        setPriceClass: setPriceClass,
                    }
                },
            },
            errContent: {
                get() {
                    let arr = [];
                    //金额
                    if (this.market.amount == "" || Number(this.market.amount) > Number(this.marketInfo.symbolData.maxAmount) || Number(this.market.amount) < Number(this.marketInfo.symbolData.minAmount)) {
                        if (Number(this.market.amount) > Number(this.marketInfo.symbolData.maxAmount)) arr.push(this.$t("message.modifyStopLoss.maxAmount")+this.marketInfo.symbolData.maxAmount);
                        else arr.push(this.$t("message.modifyStopLoss.amountNoRange"));
                    }
                    if (Number(this.market.amount*100) % Number(this.marketInfo.symbolData.volumesStep*this.marketInfo.symbolData.marginInitial*100) != 0){
                        arr.push(this.$t("message.modifyStopLoss.integerAmount")+ this.marketInfo.symbolData.volumesStep*this.marketInfo.symbolData.marginInitial)
                    }
                    //挂单价
                    if (this.marketType.type == 2 && (this.market.setPrice == '' || Number(this.market.setPrice) > Number(this.pendPrice.max) || Number(this.market.setPrice) < Number(this.pendPrice.min))) arr.push(this.$t("message.modifyStopLoss.priceNoRange"));
                    //止损
                    if (this.market.stopLoss != '' && (Number(this.market.stopLoss) > Number(this.stopLoss.max) || Number(this.market.stopLoss) < Number(this.stopLoss.min))) arr.push(this.$t("message.modifyStopLoss.stopLossNoRange"));
                    //止盈
                    if (this.market.stopProfit != '' && (Number(this.market.stopProfit) > Number(this.stopProfit.max) || Number(this.market.stopProfit) < Number(this.stopProfit.min))) arr.push(this.$t("message.modifyStopLoss.stopProfitNoRange"));
                    //可用资金不足
                    if (this.$refs.availableChild && Number(this.$refs.availableChild.available) <= 0) arr.push(this.$t("message.modifyStopLoss.insufficientFunds"));
                    return arr;
                }
            },
        },
        mounted() {
            if (!this.code) this.code = this.GetUrlParam(id);
            this.market.volume = this.marketInfo.symbolData.minVolumes || "";
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
        },
        data() {
            return {
                submitText: this.$t("message.submit"),
                util: Util,
                tradeUtil: TradeUtil,
                market: {stopLoss: "", stopProfit: "", volume: "", setPrice: "", expireType: 2, range: "", amount: ""},
                oldMarket: {},//监听market旧数据使用
                marketType: {
                    type: 1, //市价:1,挂单:2
                    direct: 1,//买:1,卖:2
                    profit: 1,//价格:1,金额:2
                    pendType: 1,//挂单类型：1:限价，2:停损
                },
                isTrue: 0,
                tabs: [
                    {name: this.$t('trade.products.marketPrice'), type: 1, tabAction: 'MarketPrice'},//市价
                    {name: this.$t('trade.products.pendingOrder'), type: 2, tabAction: 'PendingOrder'},//挂单
                ],
                switchs:false,
                Show: false,
                isShow: false,
                errMessage: '',
                isError: false,
                ProfitLossChanges: true,
                isInteger: false,
            }
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            tabclick: function (index, item) {
                this.isTrue = index;
                this.market.stopLoss = "";
                this.market.stopProfit = "";
                this.marketType.type = item.type;
                this.switchs=false;
                this.changeDirect(this.marketType.direct);
            },
            errPop() {
                this.isError = !this.isError;
            },
            blurAmount (){
                if (!this.market.amount || this.market.amount == "") {
                    this.market.amount = this.marketInfo.symbolData.minAmount
                } else {
                    this.market.amount = this.market.amount
                }
                return this.market.amount
            },
            setAmount(item) {
                this.market.amount = item;
                this.isInteger = !this.isInteger;
            },
            clickArrow() {
                this.switchs = !this.switchs;
            },
            /* 手数加减*/
            changeVolume(type) {
                const fix = String(this.marketInfo.symbolData.volumesStep).indexOf('.') >= 0 ? String(this.marketInfo.symbolData.volumesStep).split('.')[1].length : 0
                if (type == 1) {
                    // 减
                    if (!this.market.volume || this.market.volume == '') this.market.volume = Number(this.marketInfo.symbolData.minVolumes).toFixed(fix)
                    else this.market.volume = Number(Util.accSub(this.market.volume, this.marketInfo.symbolData.volumesStep)).toFixed(fix)
                    if (Number(this.market.volume) <= Number(this.marketInfo.symbolData.minVolumes).toFixed(fix)) {
                    this.market.volume = Number(this.marketInfo.symbolData.minVolumes).toFixed(fix)
                    }
                    // 超出范围弹出提示
                } else {
                    // 加
                    if (!this.market.volume || this.market.volume == '') this.market.volume = Number(this.marketInfo.symbolData.minVolumes).toFixed(fix)
                    else this.market.volume = Number(Util.accAdd(this.market.volume, this.marketInfo.symbolData.volumesStep)).toFixed(fix)
                    if (Number(this.market.volume) >= Number(this.marketInfo.symbolData.maxVolumes).toFixed(fix)) {
                    this.market.volume = Number(this.marketInfo.symbolData.maxVolumes).toFixed(fix)
                    }
                    // 超出范围弹出提示
                }
            },
            checkInteger() {
                this.isInteger = !this.isInteger
            },
            changeRangeLoss(range) {
                this.market.stopLoss = range;
            },
            changeRangeProfit(range) {
                this.market.stopProfit = range;
            },
            //涨跌样式 directType:{1:买，2:卖} type:{1:背景颜色，2:涨跌符号}
            isRise: function (obj, directType, type) {
                let val;
                let direct = directType == 1 ? "bid" : "ask";
                if (obj.preData) {
                    if (Number(obj[direct]) > Number(obj.preData[direct])) {
                        val = type == 1 ? this.marketType.direct == directType ? "buy" : "" : this.marketType.direct == directType ? "checkRise" : "rise";
                    } else if (Number(obj[direct]) < Number(obj.preData[direct])) {
                        val = type == 1 ? this.marketType.direct == directType ? "sell" : "" : this.marketType.direct == directType ? "checkFall" : "fall";
                    } else {
                        val = type == 1 ? this.marketType.direct == directType ? "level" : "" : "";
                    }
                } else {
                    if (Number(obj[direct]) > Number(obj.preClose)) {
                        val = type == 1 ? "buy" : this.marketType.direct == directType ? "checkRise" : "rise";
                    } else if (Number(obj[direct]) < Number(obj.preClose)) {
                        val = type == 1 ? "sell" : this.marketType.direct == directType ? "checkFall" : "fall";
                    } else {
                        val = type == 1 ? this.marketType.direct == directType ? "level" : "" : "";
                    }
                }
                return val;
            },
            /*切换买卖方向*/
            changeDirect(type) {
                this.marketType.direct = type;
                this.market.stopLoss = "";
                this.market.stopProfit = "";
                this.market.amount = this.marketInfo.symbolData.minAmount;
                if (this.marketType.type == 2) {//挂单
                    if (this.marketType.pendType == 1) {//限价
                        if (this.marketType.direct == 1) this.market.setPrice = this.pendPrice.max;//买
                        else if (this.marketType.direct == 2) this.market.setPrice = this.pendPrice.min;//卖
                    } else {//停损
                        if (this.marketType.direct == 1) this.market.setPrice = this.pendPrice.min;//买
                        else if (this.marketType.direct == 2) this.market.setPrice = this.pendPrice.max;//卖
                    }
                }
            },
            /*切换限价，停损*/
            changePendType() {
                this.market.stopLoss = "";
                this.market.stopProfit = "";
                if (this.marketType.pendType == 1) {//限价
                    if (this.marketType.direct == 1) this.market.setPrice = this.pendPrice.max;//买
                    else if (this.marketType.direct == 2) this.market.setPrice = this.pendPrice.min;//卖
                } else {//停损
                    if (this.marketType.direct == 1) this.market.setPrice = this.pendPrice.min;//买
                    else if (this.marketType.direct == 2) this.market.setPrice = this.pendPrice.max;//卖
                }
            },
            //止损止盈切换
            tabName: function () {
                this.ProfitLossChanges = !this.ProfitLossChanges;
                this.marketType.profit = this.ProfitLossChanges ? 1 : 2;
                if (this.market.stopLoss && this.market.stopLoss != "") {
                    if (this.marketType.type == 1) this.market.stopLoss = TradeUtil.changePipValue(this.market.stopLoss, this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.marketInfo.symbolData, this.marketType.direct, this.marketType.profit, 1,this.market.volume);
                    else if (this.marketType.type == 2) this.market.stopLoss = TradeUtil.changePipValue(this.market.stopLoss, this.market.setPrice, this.market.setPrice, this.marketInfo.symbolData, this.marketType.direct, this.marketType.profit, 1,this.market.volume);
                }
                if (this.market.stopProfit && this.market.stopProfit != "") {
                    if (this.marketType.type == 1) this.market.stopProfit = TradeUtil.changePipValue(this.market.stopProfit, this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.marketInfo.symbolData, this.marketType.direct, this.marketType.profit, 2,this.market.volume);
                    else if (this.marketType.type == 2) this.market.stopProfit = TradeUtil.changePipValue(this.market.stopProfit, this.market.setPrice, this.market.setPrice, this.marketInfo.symbolData, this.marketType.direct, this.marketType.profit, 2,this.market.volume);
                }
            },
            changeRange(range) {
                this.market.range = range
            },
            clickPop(type) {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                this.Show = !this.Show;
                this.isShow = false;
                this.isTrue = 0;
                this.isInteger=false;
                this.market.range = TradeUtil.readRangeBySource(this.marketInfo.symbolData.source) || this.marketInfo.symbolData.rangeScope;
                if (this.Show) this.changeDirect(type);
            },
            /*金额加减*/
            changeAmount(type) {
                const fix = 2;
                if (type == 1) {
                    //减
                    if (!this.market.amount || this.market.amount == "") this.market.amount = Number(this.marketInfo.symbolData.minAmount).toFixed(fix);
                    else this.market.amount = Number(Util.accSub(this.market.amount, this.marketInfo.symbolData.amouontStep)).toFixed(fix);
                    if (Number(this.market.amount) <= Number(this.marketInfo.symbolData.minAmount).toFixed(fix)) {
                        this.market.amount = Number(this.marketInfo.symbolData.minAmount).toFixed(fix);
                    }
                } else {
                    //加
                    if (!this.market.amount || this.market.amount == "") this.market.amount = Number(this.marketInfo.symbolData.minAmount).toFixed(fix);
                    else this.market.amount = Number(Util.accAdd(this.market.amount, this.marketInfo.symbolData.amouontStep)).toFixed(fix);
                    if (Number(this.market.amount) >= Number(this.marketInfo.symbolData.maxAmount).toFixed(fix)) {
                        this.market.amount = Number(this.marketInfo.symbolData.maxAmount).toFixed(fix);
                    }
                }
            },
            /*挂单价加减*/
            changeSetPrice(type) {
                if (!this.market.setPrice || this.market.setPrice == "") {
                    this.market.setPrice = this.pendPrice.min;
                }
                const fix = this.marketInfo.symbolData.digits;
                if (type == 1) {
                    this.market.setPrice = Number(Util.accSub(this.market.setPrice, this.marketInfo.symbolData.pipv)).toFixed(fix);
                    if (Number(this.market.setPrice) <= Number(this.pendPrice.min)) {
                        this.market.setPrice = Number(this.pendPrice.min).toFixed(fix);
                    }
                } else {
                    this.market.setPrice = Number(Util.accAdd(this.market.setPrice, this.marketInfo.symbolData.pipv)).toFixed(fix);
                    if (Number(this.market.setPrice) >= Number(this.pendPrice.max)) {
                        this.market.setPrice = Number(this.pendPrice.max).toFixed(fix);
                    }
                }

            },
            /*止损加减*/
            changeStopLoss(type) {
                if (!this.market.stopLoss || this.market.stopLoss == "") {
                    if (this.marketType.profit == 2) this.market.stopLoss = this.stopLoss.min;
                    else this.market.stopLoss = this.marketType.direct == 1 ? this.stopLoss.max : this.stopLoss.min;
                    return;
                }
                const fix = this.marketInfo.symbolData.digits;
                if (type == 1) {
                    //减
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopLoss = Number(Util.accSub(this.market.stopLoss, this.marketInfo.symbolData.pipv)).toFixed(fix);
                    } else {
                        //点数
                        this.market.stopLoss = Number(Util.accSub(this.market.stopLoss, 1.0)).toFixed(1);
                    }
                    if (Number(this.market.stopLoss) <= Number(this.stopLoss.min)) {
                        this.market.stopLoss = Number(this.stopLoss.min).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                } else {
                    //加
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopLoss = Number(Util.accAdd(this.market.stopLoss, this.marketInfo.symbolData.pipv)).toFixed(fix);
                    } else {
                        this.market.stopLoss = Number(Util.accAdd(this.market.stopLoss, 1.0)).toFixed(1);

                    }
                    if (Number(this.market.stopLoss) >= Number(this.stopLoss.max)) {
                        this.market.stopLoss = Number(this.stopLoss.max).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                }
            },
            /*止盈加减*/
            changeStopProfit(type) {
                if (!this.market.stopProfit || this.market.stopProfit == "") {
                    if (this.marketType.profit == 2) this.market.stopProfit = this.stopProfit.min;
                    else this.market.stopProfit = this.marketType.direct == 1 ? this.stopProfit.min : this.stopProfit.max;
                    return;
                }
                const fix = this.marketInfo.symbolData.digits;
                if (type == 1) {
                    //减
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopProfit = Number(Util.accSub(this.market.stopProfit, this.marketInfo.symbolData.pipv)).toFixed(fix);
                    } else {
                        //点数
                        this.market.stopProfit = Number(Util.accSub(this.market.stopProfit, 1.00)).toFixed(1);
                    }
                    if (Number(this.market.stopProfit) <= Number(this.stopProfit.min)) {
                        this.market.stopProfit = Number(this.stopProfit.min).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                } else {
                    //加
                    if (this.marketType.profit == 1) {
                        //价格
                        this.market.stopProfit = Util.accAdd(this.market.stopProfit, this.marketInfo.symbolData.pipv).toFixed(fix);
                    } else {
                        //点数
                        this.market.stopProfit = Number(Util.accAdd(this.market.stopProfit, 1.00)).toFixed(1);
                    }
                    if (Number(this.market.stopProfit) >= Number(this.stopProfit.max)) {
                        this.market.stopProfit = Number(this.stopProfit.max).toFixed(this.marketType.profit == 1 ? fix : 1);
                    }
                }
            },
            submit() {
                let mainH = document.getElementById("main");
                mainH.classList.toggle('mainFixed');
                if (this.errContent.length > 0 || this.submitText == this.$t('message.submitting')) return;
                this.submitText = this.$t('message.submitting');
                let req = TradeUtil.getTradeReq(this.account, this.marketInfo.symbolData);//初始化请求对象
                req.Direction = this.marketType.direct;//买卖方向
                // 订单类型- 0x01.市价建仓；0x02.Limit 建仓；0x04.Stop 建仓；0x08.市价平仓；
                req.Type = this.marketType.type;//订单类型(平仓，开仓)
                if (this.marketType.type == 1) req.Type = Constant.OrderType.OPEN;
                else if (this.marketType.type == 2) {
                    req.ExpireType = this.market.expireType;
                    if (this.marketType.pendType == 1) req.Type = Constant.OrderType.LIMIT;
                    else req.Type = Constant.OrderType.STOP;
                }

                //请求价格
                if (this.marketType.type == 1) req.RequestPrice = (this.marketType.direct == 1 ? this.marketInfo.tick.bid : this.marketInfo.tick.ask);
                else if (this.marketType.type == 2) req.RequestPrice = this.market.setPrice;

                //手数
                req.RequestVolume = this.market.volume != null && this.market.volume != "" ? this.market.volume : this.marketInfo.symbolData.minVolumes;

                //止损止盈
                if (this.market.stopLoss && this.market.stopLoss != "") {
                    if (this.marketType.profit == 1) req.StopLoss = this.market.stopLoss;
                    else if (this.marketType.profit == 2) {
                        //req.StopLossPips = this.market.stopLoss;
                        if (this.marketType.type == 2) req.StopLoss = TradeUtil.changePipValue(this.market.stopLoss, this.market.setPrice, this.market.setPrice, this.marketInfo.symbolData, this.marketType.direct, 1, 1);
                        else if (this.marketType.type == 1) req.StopLoss = TradeUtil.changePipValue(this.market.stopLoss, this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.marketInfo.symbolData, this.marketType.direct, 1, 1);
                    }
                }
                if (this.market.stopProfit && this.market.stopProfit != "") {
                    if (this.marketType.profit == 1) req.TakeProfit = this.market.stopProfit;
                    if (this.marketType.profit == 2) {
                        //req.TakeProfitPips = this.market.stopProfit;
                        if (this.marketType.type == 2) req.TakeProfit = TradeUtil.changePipValue(this.market.stopProfit, this.market.setPrice, this.market.setPrice, this.marketInfo.symbolData, this.marketType.direct, 1, 2);
                        else if (this.marketType.type == 1) req.TakeProfit = TradeUtil.changePipValue(this.market.stopProfit, this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.marketInfo.symbolData, this.marketType.direct, 1, 2);
                    }
                }
                req.Range = this.market.range;//偏差
                this.socket.tradeSocket.emit('request', Number(Constant.Req.openOrder), req);
            },
        },
        watch: {
            market: {
                //监听数据格式长度等
                deep: true,
                handler(newValue, oldValue) {
                    //止损价控制
                    if (newValue.stopLoss && newValue.stopLoss != "") {
                        if (isNaN(newValue.stopLoss) || String(newValue.stopLoss).indexOf("e") >= 0 || String(newValue.stopLoss).indexOf("-") >= 0) {
                            this.market.stopLoss = this.oldMarket.stopLoss;
                        } else if (String(newValue.stopLoss).indexOf(".") > 0 && this.marketInfo.symbolData) {
                            if (this.marketType.profit == 1 && String(newValue.stopLoss).split(".")[1].length > this.marketInfo.symbolData.digits) {//
                                this.market.stopLoss = this.oldMarket.stopLoss;
                            } else if (this.marketType.profit == 2 && String(newValue.stopLoss).split(".")[1].length > 2) {
                                this.market.stopLoss = this.oldMarket.stopLoss;
                            }
                        }
                    }
                    //止盈价控制
                    if (newValue.stopProfit && newValue.stopProfit != "") {
                        if (isNaN(newValue.stopProfit) || String(newValue.stopProfit).indexOf("e") >= 0 || String(newValue.stopProfit).indexOf("-") >= 0) {
                            this.market.stopProfit = this.oldMarket.stopProfit;
                        } else if (String(newValue.stopProfit).indexOf(".") > 0 && this.marketInfo.symbolData) {
                            if (this.marketType.profit == 1 && String(newValue.stopProfit).split(".")[1].length > this.marketInfo.symbolData.digits) {//
                                this.market.stopProfit = this.oldMarket.stopProfit;
                            } else if (this.marketType.profit == 2 && String(newValue.stopProfit).split(".")[1].length > 2) {
                                this.market.stopProfit = this.oldMarket.stopProfit;
                            }
                        }
                    }
                    //价格控制
                    if (newValue.setPrice && newValue.setPrice != "") {
                        if (isNaN(newValue.setPrice) || String(newValue.setPrice).indexOf("e") >= 0 || String(newValue.setPrice).indexOf("-") >= 0) {
                            this.market.setPrice = this.oldMarket.setPrice;
                        } else if (String(newValue.setPrice).indexOf(".") > 0 && this.marketInfo.symbolData) {
                            if (String(newValue.setPrice).split(".")[1].length > this.marketInfo.symbolData.digits) {//
                                this.market.setPrice = this.oldMarket.setPrice;
                            }
                        }
                    }

                    // 手数控制
                    if (newValue.volume && newValue.volume != '') {
                    if (isNaN(newValue.volume) || String(newValue.volume).indexOf('e') >= 0 || String(newValue.volume).indexOf('-') >= 0) {
                        this.market.volume = this.oldMarket.volume
                    } else if (String(newValue.volume).indexOf('.') > 0 && this.marketInfo.symbolData) {
                        const fix = String(this.marketInfo.symbolData.volumesStep).indexOf('.') >= 0 ? String(this.marketInfo.symbolData.volumesStep).split('.')[1].length : 0
                        if (String(newValue.volume).split('.')[1].length > fix) {
                        this.market.volume = this.oldMarket.volume
                        }
                    }
                    }

                    // //投资金额控制
                    // if (newValue.amount && newValue.amount != "") {
                    //     if (isNaN(newValue.amount) || String(newValue.amount).indexOf("e") >= 0 || String(newValue.amount).indexOf("-") >= 0) {
                    //         this.market.amount = this.oldMarket.amount;
                    //     }else if (String(newValue.amount).indexOf(".") > 0 && this.marketInfo.symbolData) {
                    //         const fix = 2;
                    //         if (String(newValue.amount).split(".")[1].length > fix) {
                    //             //小数位限制
                    //             this.market.amount = this.oldMarket.amount;
                    //         }
                    //     }
                    // }


                    // const volumeFix = String(this.marketInfo.symbolData.volumesStep).indexOf(".") >= 0 ? String(this.marketInfo.symbolData.volumesStep).split(".")[1].length : 0;
                    // if (!newValue.amount || newValue.amount == '') {
                    //     this.market.volume = "";
                    // } else if (this.marketInfo.symbolData) this.market.volume = Util.accDiv(this.market.amount, this.marketInfo.symbolData.marginInitial).toFixed(volumeFix);
                    this.oldMarket = TradeUtil.copy(this.market);
                }
            },
            simpleResponse: {
                //提交失败提示
                deep: true,
                handler(newValue, oldValue) {
                    this.submitText = this.$t("message.submit");
                    this.errMessage = this.tradeUtil.getFailMsg(newValue.Code, this.marketInfo.symbolData, this.group);
                    this.isError = !this.isError;
                    let mainH = document.getElementById("main");
                    mainH.classList.toggle('mainFixed');
                }
            },
            orderAddRet: {
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue.Type) {
                        if (newValue.Type == Constant.OrderType.LIMIT || newValue.Type == Constant.OrderType.STOP) {
                            //挂单成功
                            let data = TradeUtil.copy(newValue);
                            if (this.marketType.profit == 2) {
                                //点数下单
                                data.setStopLossTip = this.market.stopLoss;
                                data.setStopProfitTip = this.market.stopProfit;
                            }
                            this.$cookie.set('orderSuc', 'suc', {expires: 7, path: '/'});
                            this.$router.push({path: "SucOrdered", query: data});
                        }
                    }
                },
            },
            positionAddRet: {
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue.ID) {
                        if (this.orderAddRet.Type == Constant.OrderType.OPEN) {
                            //市价下单成功
                            //缓存this.marketInfo.symbolData.source     this.orderAddRet.Range
                            TradeUtil.saveRange(this.marketInfo.symbolData.source, Number(this.orderAddRet.Range).toFixed(0));

                            let data = TradeUtil.copy(newValue);
                            data.RequestPrice = data.OpenPrice;//字段转换
                            data.RequestVolume = data.Volume;//字段转换
                            data.Type = 1;//标识市价下单
                            if (this.marketType.profit == 2) {
                                //点数下单
                                data.setStopLossTip = this.market.stopLoss;
                                data.setStopProfitTip = this.market.stopProfit;
                            }
                            this.$cookie.set('orderSuc', 'suc', {expires: 7, path: '/'});
                            this.$router.push({path: "SucOrdered", query: data});
                        }
                    }
                },
            },
        }
    }
</script>
